"use client";

import { ReactNode } from "react";
import { useLinkStatus } from "next/link";

import { cn } from "@/helpers/className";

interface NavigationLinkProgressProps {
  children: ReactNode;
  className?: string;
  indicatorClassName?: string;
}

export const NavigationLinkProgress = ({
  children,
  className,
  indicatorClassName,
}: NavigationLinkProgressProps) => {
  const { pending } = useLinkStatus();

  return (
    <span className={cn("relative", className)}>
      {children}

      {pending && (
        <span
          className={cn(
            "bg-black/15 pointer-events-none absolute -bottom-1 left-0 h-0.5 w-full overflow-hidden rounded-full",
            indicatorClassName,
          )}
        >
          <span className="absolute left-[-40%] top-0 h-full w-[40%] animate-navLinkUnderlineInfiniteProgress rounded-full bg-yellow-500 [animation-delay:150ms]" />
        </span>
      )}
    </span>
  );
};

export default NavigationLinkProgress;
